/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_Proof_RemoveInputs */

const vi_tea_purchase_payment_proof_remove = /** @type {(inputs: Tea_Purchase_Payment_Proof_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa ảnh`)
};

/**

* @param {Tea_Purchase_Payment_Proof_RemoveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_proof_remove = /** @type {((inputs?: Tea_Purchase_Payment_Proof_RemoveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_Proof_RemoveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_proof_remove(inputs)
});